import { render, staticRenderFns } from "./AdminListForm.vue?vue&type=template&id=4633d67a"
import script from "./AdminListForm.vue?vue&type=script&lang=js"
export * from "./AdminListForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports